<template>
    <div :class="id + '-helper'">
        <help-icon :action="toggleTooltip"/>
        <tooltip
            v-if="showTooltip"
            :css-class="id + '-helper-tooltip'"
            :parent="$el.querySelector('.help-icon')"
            @closed="showTooltip = false"
        >
            <slot></slot>
        </tooltip>
    </div>
</template>

<script>
import HelpIcon from 'src/components/icons/Help';

export default {
    props: ['id'],
    data() {
        return {
            showTooltip: false,
        };
    },
    components: {
        HelpIcon,
    },
    methods: {
        toggleTooltip() {
            this.showTooltip = !this.showTooltip;
        },
    },
};
</script>
